import { Plugin } from 'prosemirror-state';
import { tableEditing } from 'prosemirror-tables';

import { AddMenuTable, BrowserOutline } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';
import addRowDecoration from './addRowDecoration';
import columnResizing from './columnResizeView';

function plugins({ t }: EditorOptions): Plugin[] {
  return [
    columnResizing,

    //for adding rows
    new Plugin({ props: { decorations: (state) => addRowDecoration(state, t) } }),

    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.table.title') as string,
            description: t('Lygo:Menu.table.description') as string,
            icon: BrowserOutline,
            addMenuIcon: AddMenuTable,
            addMenuItemType: addMenuItemType.advanced_blocks,
            searchWords: ['table', 'advanced'],
          },
        ]);
        return {};
      },
    }),

    tableEditing(),
  ];
}

export default plugins;
